<h3 class="mb-2">{{ 'apiUsage.title' | t }}</h3>

<h5>{{ 'apiUsage.baseUri' | t }}</h5>
<p class="no-indent">
    <span>
        <span class="d-inline">{{ apiUrl }}</span>
    </span>
</p>

<h5>{{ 'apiUsage.authentication' | t }}</h5>
<p>
    <strong> {{ 'apiUsage.basicAuthentication' | t }} </strong>
    <span>
        {{ 'apiUsage.basicAuthenticationText' | t }}
    </span>
</p>
<p>
    <strong> {{ 'apiUsage.example' | t }} </strong>
    <span>
        <pre class="example-block">
Identifier = "abc"
Password = "123"
Base64 = "YWJjOjEyMw==" <-- (Base64("abc:123"))
================================================
Authentication = "Basic YWJjOjEyMw=="</pre
        >
    </span>
</p>

<h5>{{ 'apiUsage.httpMethods' | t }}</h5>
<p>
    <strong> GET </strong>
    <span> {{ 'apiUsage.getDescription' | t }} </span>
</p>
<p>
    <strong> POST </strong>
    <span> {{ 'apiUsage.postDescription' | t }} </span>
</p>
<p>
    <strong> Delete </strong>
    <span> {{ 'apiUsage.deleteDescription' | t }} </span>
</p>
